// extracted by mini-css-extract-plugin
export var active = "_dp-2";
export var recordingDot = "_dp-1";
export var recordingIndicator = "_dp-0";